import { enqueueSnackbar } from "notistack";
import { apiCall } from ".";
import { getSession } from "../handlers/getSession";
import { getTenant } from "../handlers/getTenant";
import { getErrorMessage } from "./errorMessages";
//function to handle errors and display them to the user
const showErrorMessage = (message) => {
  enqueueSnackbar(message, {
    variant: "error",
    preventDuplicate: true,
    autoHideDuration: 10000,
  });
};

// FUNCION MAIN DE AI Ethics
export const generateAiInvestigtionPlan = async (
  data = { report_id: "", investigation_alias: "" },
) => {
  //show_all: true
  const tenant = getTenant();
  const session = getSession();
  if (!session) return;

  try {
    const resp = await apiCall.post(
      `${tenant}/api/ai/investigation/plans/`,
      data,
      {
        headers: {
          IdToken: session.IdToken,
          Authorization: `Bearer ${session.AccessToken}`,
        },
      },
    );
    return resp.data.response.plans;
  } catch (error) {
    // showErrorMessage(`${language.error_obtaining_consultant_review_details}`);
    console.error(error);
    throw error;
    // return { error: true };
  }
};

export const generateAiInterview = async (
  data = {
    report_id: "",
    investigation_alias: "",
    name: "",
    position: "",
    type: "",
  },
) => {
  //show_all: true
  const tenant = getTenant();
  const session = getSession();
  if (!session) return;

  try {
    const resp = await apiCall.post(
      `${tenant}/api/ai/investigation/interview/`,
      data,
      {
        headers: {
          IdToken: session.IdToken,
          Authorization: `Bearer ${session.AccessToken}`,
        },
      },
    );
    console.log(resp);

    return resp.data.response;
  } catch (error) {
    // showErrorMessage(`${language.error_obtaining_consultant_review_details}`);
    console.error(error);
    throw error;
    // return { error: true };
  }
};

// LIST CATALOGUE ENDPOINT
export const listCatalogues = async () => {
  const tenant = getTenant();
  try {
    const resp = await apiCall.get(`${tenant}/api/list/catalogues/`);
    return resp.data;
  } catch (error) {
    showErrorMessage(getErrorMessage(error, "ai"));
    console.error(error);
  }
};

export const summarizeInterviewAI = async (data) => {
  const tenant = getTenant();
  const session = getSession();
  if (!session) return;

  try {
    const resp = await apiCall.post(
      `${tenant}/api/ai/investigation/analyze/`,
      data,
      {
        headers: {
          IdToken: session.IdToken,
          Authorization: `Bearer ${session.AccessToken}`,
        },
      },
    );
    return resp.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};
